import { useContext } from 'react'
import {
  SsrDataContext,
  type SsrPageData,
} from '@presentation/ssr/SsrDataContext'

const DATE_KEYS = new Set([
  'createdAt',
  'createdTime',
  'publishTime',
  'releaseDate',
  'syncedAt',
  'timestamp',
  'updatedAt',
  'videoPublishedAt',
  'videoSortDate',
  'vimeoLastSeenAt',
  'vimeoMatchedAt',
  'vimeoSourcePublishedAt',
  'webinarDate',
])

function reviveDates(value: unknown, key = ''): unknown {
  if (typeof value === 'string' && DATE_KEYS.has(key)) {
    const parsedDate = new Date(value)
    return Number.isNaN(parsedDate.getTime()) ? value : parsedDate
  }

  if (Array.isArray(value)) {
    return value.map((item) => reviveDates(item))
  }

  if (!value || typeof value !== 'object') {
    return value
  }

  return Object.fromEntries(
    Object.entries(value as Record<string, unknown>).map(([entryKey, entryValue]) => [
      entryKey,
      reviveDates(entryValue, entryKey),
    ]),
  )
}

export function useSsrPageData(): SsrPageData | null {
  return useContext(SsrDataContext)
}

export function readSsrDataFromWindow(): SsrPageData | null {
  if (typeof window === 'undefined' || !window.__PARKINSONS_INSIGHTS_SSR__) {
    return null
  }

  return reviveDates(window.__PARKINSONS_INSIGHTS_SSR__) as SsrPageData
}
